"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Router = exports.Route = void 0;

var _Tools = require("../Tools");

var _Group = require("../Role/Group");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Route {
  constructor() {
    _defineProperty(this, "endpoint", '/');

    _defineProperty(this, "method", 'get');

    _defineProperty(this, "no_env", false);

    _defineProperty(this, "is_public", false);

    _defineProperty(this, "role", _Group.Role.NO_ROLE);

    _defineProperty(this, "middleware", {
      before: null,
      after: null
    });

    _defineProperty(this, "action", function (req, res, next) {
      next();
    });
  }

  static fromObject(r) {
    let route = new Route();
    Object.keys(r || {}).forEach(key => {
      let value = r[key];

      switch (key) {
        case 'endpoint':
        case 'method':
        case 'no_env':
        case 'is_public':
        case 'role':
        case 'action':
        case 'middleware':
          route[key] = value;
          break;
      }
    });
    return route;
  }

}

exports.Route = Route;

class Router {
  static makeRoutes(router, prefix, routes = [Route.fromObject({
    endpoint: ''
  })]) {
    routes.forEach(route => {
      var _route$middleware, _route$middleware2;

      let urlPath = _Tools.StringTemplate.replace('{prefix}/{path}', {
        '{prefix}': prefix,
        '{path}': route.endpoint || ''
      });

      let actions = Array.isArray(route.action) ? route.action : [route.action];

      if ((_route$middleware = route.middleware) !== null && _route$middleware !== void 0 && _route$middleware.before) {
        actions.unshift(...(Array.isArray(route.middleware.before) ? route.middleware.before : [route.middleware.before]));
      }

      if ((_route$middleware2 = route.middleware) !== null && _route$middleware2 !== void 0 && _route$middleware2.after) {
        actions.push(...(Array.isArray(route.middleware.after) ? route.middleware.after : [route.middleware.after]));
      }

      router[route.method](urlPath, actions);
    });
    return router;
  }

}

exports.Router = Router;